<template>
  <div class="row">
    <v-col sm="12" md="4" v-for="evento in eventi" v-bind:key="evento.idEvento">
      <base-material-card color="transparent" image class="evento-card">
        <template v-slot:image>
          <v-img cover :src="evento.image" />
        </template>
        <v-card v-if="evento.showCountdown">
          <v-card-title>{{ $t('booking_deadline') }}</v-card-title>
          <flip-countdown :deadline="evento.bookingDeadline"></flip-countdown>
        </v-card>
        <v-tooltip right v-if="evento.extUrl">
          <template v-slot:activator="{ on, attrs }">
            <div class="badge-container" v-bind="attrs" v-on="on">
              <div class="badge">
                <img :src="evento.badge" />
              </div>
            </div>
          </template>
          <span>{{ $t("evento") + "&nbsp;" + enteDex }}</span>
        </v-tooltip>
        <v-card-title class="justify-center font-weight-light">{{
          evento.title
        }}</v-card-title>

        <v-card-text class="body-1 text-center mb-3 font-weight-light grey--text"><span
            v-html="evento.description"></span></v-card-text>

        <template v-slot:actions>
          <div class="display-2 font-weight-light grey--text" v-html="evento.price" />

          <v-spacer />
          <v-btn v-if="mode === 'extWidget' || (auth && !evento.partecipo && !evento.bookingDeadline < new Date())"
            @click="bookEvent(evento)" color="primary">{{
              $t("booking") }}</v-btn>
          <h2 class="success--text text--lighten-1" v-if="auth && evento.partecipo">
            {{ $t("confirmed").toUpperCase() }}
          </h2>
          <v-btn color="primary" @click="bookEvent(evento)" v-if="auth &&
            evento.partecipo &&
            (evento.canUpgrade || RBAC_INSERT_OTHER_USER)
            " icon>
            <v-icon>mdi-arrow-up-circle</v-icon>
          </v-btn>

          <v-spacer />

          <span class="caption grey--text font-weight-light">
            <v-icon small>mdi-map-marker</v-icon>
            {{ evento.location }}
          </span>
        </template>
      </base-material-card>
    </v-col>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import FlipCountdown from 'vue2-flip-countdown'
import moment from "moment";

export default {
  name: "list-eventi",
  components: { FlipCountdown },
  props: {
    mode: null,
    auth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      RBAC_INSERT_OTHER_USER: false,
      eventi: [],
    };
  },
  computed: {
    enteDex: function () {
      return window.systemData &&
        window.systemData.haveEnte &&
        window.systemData.ente &&
        window.systemData.ente.ragSoc
        ? window.systemData.ente.ragSoc
        : false;
    },
  },
  methods: {
    bookEvent: function (evento) {
      let _ = this;
      if (this.mode === "extWidget")
        window.open("/portal/eventi/iscrizioneEvento/" + evento.id);
      else {
        if (evento.extUrl) {
          Swal.fire({
            title: _.$t("redirect_to_external_site"),
            html: _.enteDex ? _.enteDex : evento.extUrl,
          }).then((result) => {
            if (result && result.value) window.open(evento.extUrl);
          });
        } else
          this.$router.push("/portal/eventi/iscrizioneEvento/" + evento.id);
      }
    },
  },
  mounted() {
    this.RBAC_INSERT_OTHER_USER = this.checkUserRole(
      "eventi",
      "INSERT_OTHER_USER"
    );
    let _ = this;
    let url = "/public/eventi/listEventi";
    if (this.auth) url = "/auth/eventi/listEventi";
    if (!this.mode || this.mode !== "extWidget") url += "?showEnte=true";
    this.chiamataAxios("GET", url).then((response) => {
      if (response && response.data && response.data.eventi) {
        let data = response.data.eventi;
        for (let e = 0; e < data.length; e++) {
          let evento = {
            title: data[e].titolo,
            id: data[e].idEvento,
            description: data[e].locationDescr,
            location: data[e].locationName,
            image: data[e].image,
            badge: data[e].badge,
            extUrl: data[e].extUrl,
            showCountdown: data[e].showCountdown === 1,
            bookingDeadline: moment(data[e].bookingDeadline).format('YYYY-MM-DD HH:mm:ss'),
            partecipo: false,
            canUpgrade: false,
            key: data[e].custId + '_' + data[e].id
          };
          if (data[e].infoEvento) {
            evento.partecipo = data[e].infoEvento.partecipo;
            evento.canUpgrade = data[e].infoEvento.canUpgrade;
            if (
              data[e].infoEvento.importoMin === data[e].infoEvento.importoMax
            ) {
              evento.price = data[e].infoEvento.importoMin + "&euro;";
              evento.price = data[e].infoEvento.importoMin + "&euro;";
            } else {
              evento.price =
                data[e].infoEvento.importoMin +
                " - " +
                data[e].infoEvento.importoMax +
                "&euro;";
            }
          }

          _._data.eventi.push(evento);
        }
      }
    });
  },
};
</script>
<style >
.evento-card {
  margin-top: 50px;
}

.locandina {
  width: 300px;
  height: 150px;
}

.body-1 {
  height: 150px;
  overflow-y: auto;
}

.badge-container,
.badge-container:before,
.badge-container:after,
.badge-container .badge {
  height: 60px;
  width: 60px;
  background: var(--v-primary-base);
}

.badge img {
  height: 50px;
  width: 50px;
  top: 5px;
  left: 5px;
  position: absolute;
}

.badge-container:before,
.badge-container:after {
  content: "";
  position: absolute;
}

.badge-container {
  margin: 20px auto;
  /* Centering for demo */
  position: absolute;
  /* Context */
  top: -70px;
  left: 0;
  float: right;
  background-color: var(--v-primary-base);
  transform-origin: center;
  transition: 0.3s all ease-out;
  height: 60px;
  width: 60px;
  z-index: 10;
}

.badge-container:before {
  top: 0;
  left: 0;
  -webkit-transform: rotate(22.5deg);
  -moz-transform: rotate(22.5deg);
  -ms-transform: rotate(22.5deg);
  -o-transform: rotate(22.5deg);
  transform: rotate(22.5deg);
  z-index: 10;
  height: 60px;
  width: 60px;
}

.badge-container:after {
  top: 0;
  left: 0;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  background-color: var(--v-primary-base);
  height: 60px;
  width: 60px;
}

.badge-container .badge {
  height: 60px;
  /* height minus padding */
  width: 60px;
  /* height minus padding */
  position: absolute;
  bottom: 0;
  right: 0;
  -webkit-transform: rotate(-22.5deg);
  -moz-transform: rotate(-22.5deg);
  -ms-transform: rotate(-22.5deg);
  -o-transform: rotate(-22.5deg);
  transform: rotate(-22.5deg);
  z-index: 10;
  /* important so the text shows up */
}

.badge {
  height: 60px;
  width: 60px;
}

.badge-container:hover {
  transform: matrix3d(1.058,
      0.38,
      -0.38,
      0,
      -0.38,
      1.058,
      -0.38,
      0,
      0.38,
      0.38,
      0.8464,
      0,
      0,
      0,
      0,
      1);
  -webkit-transform: matrix3d(1.058,
      0.38,
      -0.38,
      0,
      -0.38,
      1.058,
      -0.38,
      0,
      0.38,
      0.38,
      0.8464,
      0,
      0,
      0,
      0,
      1);
}
</style>